<template>
  <div class="book-address-wrapper">
    <div class="address-form">
      <div class="address-item flex">
        <div class="address-text"><input type="text" v-model="name" placeholder="收件人姓名"></div>
        <div class="address-text"><input type="tel" v-model="contact" placeholder="手机号(限中国大陆)"></div>
      </div>
      <div class="address-item">
        <div class="area-picker" @click="addressPickerShow = true">
          <div class="placeholder" v-if="region.length <= 0">选择省市区</div>
          <div class="value" v-else>{{region[0] + region[1] + region[2]}}</div>
          <icon icon-class="navigation-arrow"></icon>
        </div>
      </div>
      <div class="address-item">
        <input type="text" class="address-detail" placeholder="详细地址" v-model="detailAddress">
      </div>
    </div>
    <div class="save-address"><button class="save-button" @click="saveAddress">保存地址</button></div>
    <!-- 地区选择 -->
    <van-popup v-model="addressPickerShow" position="bottom">
      <van-area
        :area-list="areaList"
        :columns-num="3"
        title="省市地区"
        :value="cityCode"
        @cancel="addressPickerShow = false"
        @confirm="confirmLocation" />
    </van-popup>
  </div>
</template>

<style lang="less" scoped>
  .book-address-wrapper{
    min-height: 100vh;
    padding-top: 20px;
    background: #FAFAFA;
    .address-form{
      background: #FFF;
      .address-item{
        width: 100%;
        height: 52px;
        border-bottom: 1px solid #F3F3F3;
        &.flex{
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .address-text{
          width: 50%;
          padding: 0 10px 0 24px;
          input{
            font-size: 14px;
            width: 100%;
            color: #333;
          }
          &:last-child{
            border-left: 1px solid #F3F3F3;
          }
        }
        .area-picker{
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          height: 100%;
          padding: 0 24px;
          font-size: 14px;
          .placeholder{
            color: #999;
          }
          svg{
            font-size: 14px;
            color: #999;
          }
        }
        .address-detail{
          width: 100%;
          font-size: 14px;
          color: #333;
          padding: 0 24px;
          line-height: 22px;
          margin: 15px 0;
        }
      }
    }
    .save-address{
      margin: 44px 24px 0 24px;
      .save-button{
        width: 100%;
        border: 0;
        background: @cano;
        color: #FFF;
        font-size: 16px;
        height: 44px;
        line-height: 44px;
        border-radius: 44px;
        box-shadow: 0 4px 10px 0 rgba(77,162,199,.3);
        transition: all .2s ease;
        &:active{
          opacity: .8;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import areaList from '../../untils/area'
  export default {
    data() {
      return {
        name: '',
        contact: null,
        region: [],
        detailAddress: '',
        areaList,
        cityCode: '',
        addressPickerShow: false,
      }
    },
    created() {
      console.log(this.areaList)
      let addressData = store.get('bookAddress');
      if(addressData) {
        this.name = addressData.name;
        this.contact = addressData.contact;
        this.region = addressData.region;
        this.detailAddress = addressData.detailAddress;
        for(let code in areaList.county_list) {
          if(areaList.county_list[code] == this.region[2]) {
            this.cityCode = code;
          }
        }
      }
    },
    methods: {
      confirmLocation(location) {
        this.region = [location[0].name, location[1].name, location[2].name];
        this.cityCode = location[2].code;
        this.addressPickerShow = false;
      },
      saveAddress() {
        if(!this.name) {
          this.$notify('请输入收件人姓名');return;
        }
        if(!this.contact) {
          this.$notify('请输入手机号');return;
        }
        if(!/^1\d{10}$/.test($.trim(this.contact))) {
          this.$notify('请输入正确的手机号');return;
        }
        if(!this.cityCode){
          this.$notify('请选择省市地区');return;
        }
        if(!this.detailAddress){
          this.$notify('请输入详细地址');return;
        }

        store.set('bookAddress', {
          name: this.name,
          contact: this.contact,
          region: this.region,
          detailAddress: this.detailAddress
        })
        this.$router.back();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Book/address.vue